import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const LoginStyled = styled.div`
    width: 464px;
    margin: 64px auto;
    @media (max-width: ${BREAKPOINTS.small}px) {
        margin: 0 auto;
        width: 100%;
        background: var(--app-bg-modal-color);
    }
`;

export const LoginBoxStyled = styled.div`
    font-size: 16px;
    background: var(--app-bg-modal-color);
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    padding: 32px 40px 48px;
    position: relative;
    @media (max-width: ${BREAKPOINTS.small}px) {
        box-shadow: none;
        padding: 24px 16px;
    }
`;

export const LoginForgotPasswordLinkContainerStyled = styled.div`
    display: flex;
    justify-content: end;
    margin-bottom: 32px;
`;

export const LoginGoogleStyled = styled.div`
    svg {
        margin-right: 12px;
    }
`;
